module.exports = __webpack_public_path__ + "img/crop-white.ace184d4.png";